import { Component, OnInit } from '@angular/core';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'marketplace-profile',
  templateUrl: './marketplace-profile.component.html',
  styleUrls: ['./marketplace-profile.component.scss'],
})
export class MarketplaceProfileComponent implements OnInit {
  public tab: string = 'shop';
  public showProfileMenu: boolean = false;
  public isLoading: boolean = false;
  public isLogin: boolean = false;
  focusInput: boolean = false;
  public isDisabled: boolean = false;

  public currentlyTalkingTo = null;
  /**
   * Constructor
   */
  constructor(
    private sharedService: SharedService,
    public roleService: RoleService,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void {
    this.sharedService.initTabProfile$.subscribe((params: any) => {
      if (params == 'close') {
        document.body.style.overflow = '';
        this.showProfileMenu = false;
      } else {
        document.body.style.overflow = 'hidden';
        this.showProfileMenu = true;
        this.tab = params;
      }
    });
    // this.checkValueAfterDelay()
    // this.sharedService.focusInputChat$.subscribe(arg => {
    //   this.focusInput = arg
    // });
    this.checkIfLogin();
  }
  closeMenu() {
    document.body.style.overflow = '';
    this.showProfileMenu = false;
  }

  public checkIfLogin() {
    this.local.getUserDetailsObserver().subscribe((user) => {
      this.isDisabled = user?.isDisabled;
      if (!user && this.showProfileMenu) {
        this.closeMenu();
      }
    });
  }
}
